(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[453],{

/***/ 76266:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/check-email",
      function () {
        return __webpack_require__(45959);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ EmailCheck; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./styles/B2C/EmailCheck.module.scss
var EmailCheck_module = __webpack_require__(81490);
var EmailCheck_module_default = /*#__PURE__*/__webpack_require__.n(EmailCheck_module);
;// CONCATENATED MODULE: ./utils/b2cAuthApi.ts
const BASE_URL = "https://xkfy545yf0.execute-api.ap-south-1.amazonaws.com/cf/v1";
async function checkEmail(email, preferences, partnerUuid) {
    // Defense-in-depth: even if a caller passes an object with all-empty arrays, drop it.
    // Sending empty arrays causes the BE to overwrite stored prefs with `[]`.
    const hasRealPrefs = Boolean(preferences && ((preferences.countries?.length || 0) > 0 || (preferences.studyLevels?.length || 0) > 0 || (preferences.studyAreas?.length || 0) > 0));
    // partnerUuid is optional on the BE schema; when SO knows it (from b2c_prefs),
    // forward it so BE can recover routing for Frappe-only leads that lack parent_partner_details.
    const res = await fetch(`${BASE_URL}/b2c/check-email`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email,
            ...partnerUuid ? {
                partnerUuid
            } : {},
            ...hasRealPrefs ? {
                preferences
            } : {}
        })
    });
    if (!res.ok) throw new Error("Failed to check email");
    const json = await res.json();
    return json.data;
}

// EXTERNAL MODULE: ./utils/b2cIcons.tsx
var b2cIcons = __webpack_require__(54189);
// EXTERNAL MODULE: ./utils/b2c/prefs.ts
var prefs = __webpack_require__(39156);
// EXTERNAL MODULE: ./utils/b2c/urls.ts
var urls = __webpack_require__(11714);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var constants = __webpack_require__(90017);
;// CONCATENATED MODULE: ./utils/b2c/cookies.ts

function setB2cUserTypeCookie(userType, domain, maxAge = 3600) {
    document.cookie = `${constants/* COOKIE_NAME_B2C_USER_TYPE */.Mj}=${userType}; path=/; domain=${domain}; max-age=${maxAge}`;
}
function getB2cUserTypeCookie() {
    if (typeof document === "undefined") return null;
    return document.cookie.split("; ").find((row)=>row.startsWith(`${COOKIE_NAME_B2C_USER_TYPE}=`))?.split("=")[1] ?? null;
}

// EXTERNAL MODULE: ./utils/b2c/sourceTracking.ts
var sourceTracking = __webpack_require__(3265);
;// CONCATENATED MODULE: ./pages/check-email.tsx
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];












function EmailCheck() {
    const router = (0,next_router.useRouter)();
    const { 0: email , 1: setEmail  } = (0,react.useState)("");
    const { 0: loading , 1: setLoading  } = (0,react.useState)(false);
    const { 0: error , 1: setError  } = (0,react.useState)("");
    const storedPartnerUuid = (0,prefs/* readB2cPrefs */.WS)()?.partnerUuid ?? "";
    (0,react.useEffect)(()=>{
        if (router.query.from === "login") {
            (0,prefs/* clearB2cPrefs */.BL)();
        }
    }, [
        router.query.from
    ]);
    // When navigating to /onboarding we intentionally leave loading=true, which
    // makes this page a bfcache snapshot with a frozen spinner. On a back-button
    // restore the JS state is resumed as-is (React never re-mounts), so the loader
    // would spin forever. Reset it whenever the page is shown from bfcache.
    (0,react.useEffect)(()=>{
        const handlePageShow = (event)=>{
            if (event.persisted) {
                setLoading(false);
                setError("");
            }
        };
        window.addEventListener("pageshow", handlePageShow);
        return ()=>window.removeEventListener("pageshow", handlePageShow);
    }, []);
    const routeByEmailExistence = async (trimmedEmail)=>{
        setError("");
        setLoading(true);
        try {
            const storedPrefs = (0,prefs/* readB2cPrefs */.WS)();
            const apiPrefs = storedPrefs ? (0,prefs/* buildApiPreferences */.cd)(storedPrefs) : undefined;
            const prefsPartnerUuid = storedPrefs?.partnerUuid?.trim() || undefined;
            const result = await checkEmail(trimmedEmail, apiPrefs, prefsPartnerUuid);
            if (result.exists) {
                // Set b2cUserType cookie so CF login knows how to redirect after OTP
                setB2cUserTypeCookie(result.userType ?? "student", new URL(constants/* CF_APP_URL */.AO).hostname);
                // Existing user — CF login page handles OTP send+verify internally.
                // Read source context but do NOT clear here: a refresh on this page must
                // still see the context, and the next /onboarding visit (or login click)
                // will overwrite it anyway.
                const { sourceUrl: storedSourceUrl , primarySource: storedPrimarySource , fifthStepVisible  } = (0,sourceTracking/* readSourceContext */.pi)();
                // If the user came through the wizard, signal CF to route them to Explore
                // Universities instead of Home. CF page renders with the user's saved CF prefs
                // (we do NOT forward wizard prefs — saved preferences stay authoritative).
                const cameFromJourney = (0,prefs/* hasVisibleWizardPrefs */.Vl)(storedPrefs);
                window.location.href = (0,urls/* studentPlatformUrl */.us)(constants/* CF_APP_URL */.AO, result.partnerUuid ?? "", result.uuid ?? "", "login", storedSourceUrl, cameFromJourney, storedPrimarySource, fifthStepVisible);
                return;
            }
            if (storedPrefs && (0,prefs/* arePrefsComplete */.VG)(storedPrefs)) {
                // Strict guard: never forward to CF without a valid partnerUuid
                // (arePrefsComplete already requires it; this is defense-in-depth)
                const partnerUuid = storedPrefs.partnerUuid?.trim() ?? "";
                if (!partnerUuid) {
                    setError("Your preferences are incomplete. Please complete onboarding to continue.");
                    sessionStorage.setItem(constants/* STORAGE_KEY_B2C_PENDING_EMAIL */.Yv, trimmedEmail);
                    setTimeout(()=>{
                        window.location.href = "/onboarding";
                    }, 1500);
                    return;
                }
                const encodedPrefs = Buffer.from(JSON.stringify(storedPrefs)).toString("base64");
                const { sourceUrl: storedSourceUrl1 , primarySource: storedPrimarySource1 , fifthStepVisible: fifthStepVisible1  } = (0,sourceTracking/* readSourceContext */.pi)();
                window.location.href = (0,urls/* signUpUrl */.LP)(constants/* CF_APP_URL */.AO, partnerUuid, encodedPrefs, trimmedEmail, storedSourceUrl1, storedPrimarySource1, fifthStepVisible1);
                return;
            }
            // No prefs or incomplete — show user-facing reason briefly, then redirect to onboarding
            const missing = (0,prefs/* getMissingPrefFields */.fW)(storedPrefs);
            const reason = missing.length ? `Please complete: ${missing.join(", ")}.` : "Please complete your study preferences to continue.";
            setError(reason);
            sessionStorage.setItem(constants/* STORAGE_KEY_B2C_PENDING_EMAIL */.Yv, trimmedEmail);
            // Keep loading=true so submit button stays disabled during the 1.5s message window
            setTimeout(()=>{
                window.location.href = "/onboarding";
            }, 1500);
        } catch (err) {
            console.error("[check-email] Email verification failed:", err);
            setError("Something went wrong. Please try again.");
            setLoading(false);
        }
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        const trimmedEmail = email.trim();
        if (!trimmedEmail) {
            setError("Please enter your email address.");
            return;
        }
        if (!(0,constants/* isValidEmail */.vV)(trimmedEmail)) {
            setError("Please enter a valid email address.");
            return;
        }
        await routeByEmailExistence(trimmedEmail);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).page || ""),
        children: [
            (0,jsx_runtime.jsx)((style_default()), {
                id: "a1b98613b6315dd",
                children: '[id^="kiwi-"],iframe[id^="kiwi-"]{display:none!important}'
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).loaderOverlay || ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).spinner || "")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).content || ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).logo || ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(b2cIcons/* KcLogo */.UK, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit,
                        noValidate: true,
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).card || ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).cardHeader || ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).titleRow || ""),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).title || ""),
                                                children: "Sign In to continue"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    window.location.href = router.query.from === "login" ? "/" : "/search";
                                                },
                                                "aria-label": "Close",
                                                className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).closeBtn || ""),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(b2cIcons/* CloseIcon */.Tw, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).subtitle || ""),
                                        children: "Enter email address then you can enter the verification code."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).inputGroup || ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "email",
                                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).label || ""),
                                        children: "Email Address*"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).inputWrapper || ""),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                id: "email",
                                                type: "email",
                                                inputMode: "email",
                                                autoFocus: true,
                                                placeholder: "Enter Email",
                                                value: email,
                                                onChange: (emailEvent)=>{
                                                    setEmail(emailEvent.target.value);
                                                    if (error) setError("");
                                                },
                                                autoComplete: "email",
                                                className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).input || "")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(b2cIcons/* MailIcon */.bV, {
                                                className: (EmailCheck_module_default()).mailIcon
                                            })
                                        ]
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).errorText || ""),
                                        children: error
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "submit",
                                disabled: loading || !(0,constants/* isValidEmail */.vV)(email.trim()),
                                className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).button || ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-a1b98613b6315dd",
                                        children: loading ? "Checking..." : "Continue"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(b2cIcons/* ArrowRightIcon */.LZ, {
                                        className: (EmailCheck_module_default()).buttonIcon
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).footer || ""),
                                children: [
                                    "Don't have an account?",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: `${constants/* CF_APP_URL */.AO}/student-platform/${storedPartnerUuid}/sign-up`,
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            const trimmedEmail = email.trim();
                                            if (!trimmedEmail) {
                                                setError("Email is mandatory. Please enter your email address.");
                                                return;
                                            }
                                            if (!(0,constants/* isValidEmail */.vV)(trimmedEmail)) {
                                                setError("Please enter a valid email address.");
                                                return;
                                            }
                                            if (loading) return;
                                            void routeByEmailExistence(trimmedEmail);
                                        },
                                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).footerLink || ""),
                                        children: "Create Account"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "aria-hidden": "true",
                className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).bottomIllustration || ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/cloud-left.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).cloudLeft || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/cloud-right.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).cloudRight || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/tower-left.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).towerLeft || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/building-tall-left.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).buildingTallLeft || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/building-grid.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).buildingGrid || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/ferris-wheel.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).ferrisWheel || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/temple.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).temple || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/building-tall-right.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).buildingTallRight || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/moon.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).moon || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/tower-right.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).towerRight || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/building-with-door.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).buildingWithDoor || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/mobile-sun.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).mobileSun || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/mobile-temple.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).mobileTemple || "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/b2c/sign-in/mobile-pagoda.svg",
                        alt: "",
                        className: "jsx-a1b98613b6315dd" + " " + ((EmailCheck_module_default()).mobilePagoda || "")
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 11714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LP": function() { return /* binding */ signUpUrl; },
/* harmony export */   "us": function() { return /* binding */ studentPlatformUrl; }
/* harmony export */ });
/* unused harmony export studentPlatformPath */
function studentPlatformPath(partnerUuid, studentId, route) {
    return `/student-platform/${partnerUuid}/${studentId}/${route}`;
}
function studentPlatformUrl(cfAppUrl, partnerUuid, studentId, route, sourceUrl, fromJourney, primarySource, fifthStepVisible) {
    const base = `${cfAppUrl}${studentPlatformPath(partnerUuid, studentId, route)}`;
    const params = new URLSearchParams();
    if (sourceUrl) params.set("sourceUrl", sourceUrl);
    if (fromJourney) params.set("fromJourney", "1");
    if (primarySource) params.set("primarySource", primarySource);
    if (fifthStepVisible !== undefined) params.set("fifthStepVisible", fifthStepVisible ? "1" : "0");
    const qs = params.toString();
    return qs ? `${base}?${qs}` : base;
}
function signUpUrl(cfAppUrl, partnerUuid, prefs, email, sourceUrl, primarySource, fifthStepVisible) {
    const base = `${cfAppUrl}/student-platform/${partnerUuid}/sign-up`;
    const params = new URLSearchParams();
    if (prefs) params.set("prefs", prefs);
    if (email) params.set("email", email);
    if (sourceUrl) params.set("sourceUrl", sourceUrl);
    if (primarySource) params.set("primarySource", primarySource);
    if (fifthStepVisible !== undefined) params.set("fifthStepVisible", fifthStepVisible ? "1" : "0");
    const qs = params.toString();
    return qs ? `${base}?${qs}` : base;
}


/***/ }),

/***/ 81490:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"EmailCheck_page__lVNmz","content":"EmailCheck_content__nmERL","logo":"EmailCheck_logo__iwayp","card":"EmailCheck_card__jK1KH","cardHeader":"EmailCheck_cardHeader__fbe3d","titleRow":"EmailCheck_titleRow__HwRB_","closeBtn":"EmailCheck_closeBtn__OzSYa","title":"EmailCheck_title__jsKZf","subtitle":"EmailCheck_subtitle__am2ZF","inputGroup":"EmailCheck_inputGroup__dTNAf","label":"EmailCheck_label__UiDOW","inputWrapper":"EmailCheck_inputWrapper__CF8iK","input":"EmailCheck_input__ywm8k","mailIcon":"EmailCheck_mailIcon__8NecO","button":"EmailCheck_button__b0Arr","buttonIcon":"EmailCheck_buttonIcon__qmZhQ","errorText":"EmailCheck_errorText__i4pAR","footer":"EmailCheck_footer__31dD_","footerLink":"EmailCheck_footerLink___rwZL","bottomIllustration":"EmailCheck_bottomIllustration__PLx4t","cloudLeft":"EmailCheck_cloudLeft__07T_r","cloudRight":"EmailCheck_cloudRight__EZbOj","towerLeft":"EmailCheck_towerLeft__NEF1M","buildingTallLeft":"EmailCheck_buildingTallLeft__evoKQ","buildingGrid":"EmailCheck_buildingGrid__Rypx2","ferrisWheel":"EmailCheck_ferrisWheel__DcJm0","temple":"EmailCheck_temple__HYtOa","buildingTallRight":"EmailCheck_buildingTallRight__KL5XF","moon":"EmailCheck_moon__s1Hly","towerRight":"EmailCheck_towerRight__plAfh","buildingWithDoor":"EmailCheck_buildingWithDoor__NZf__","mobileSun":"EmailCheck_mobileSun__aKjhi","mobileTemple":"EmailCheck_mobileTemple__705Cv","mobilePagoda":"EmailCheck_mobilePagoda__joi11","loaderOverlay":"EmailCheck_loaderOverlay__6j39u","spinner":"EmailCheck_spinner__UXpYM","spin":"EmailCheck_spin__jIXyJ"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1876,9774,2888,179], function() { return __webpack_exec__(76266); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);